import {
  Alert,
  Box,
  IconButton,
  Snackbar,
  Typography,
  useMediaQuery,
} from '@mui/material';
import React, { useState } from 'react';
import useSignOut from 'react-auth-kit/hooks/useSignOut';
import { useNavigate } from 'react-router-dom';
import LogoutIcon from '@mui/icons-material/Logout';
import { useDispatch } from 'react-redux';
import { clearMunicipality } from '../redux/municipialitySlice';

const SignOutButton: React.FC = () => {
  const { REACT_APP_API_URL } = process.env;
  const [error, setError] = useState<string | null>(null);
  const [snackbarOpen, setSnackbarOpen] = useState<boolean>(false);
  const signOut = useSignOut();
  const navigate = useNavigate();
  const username = localStorage.getItem('username');
  const isMobile = useMediaQuery('(max-width:600px)');

  const dispatch = useDispatch();
  const handleSignOut = async () => {
    setError(null);
    setSnackbarOpen(false);
    dispatch(clearMunicipality());
    try {
      const response = await fetch(
        `${REACT_APP_API_URL}/api/token/blacklist/`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            refresh: localStorage.getItem('refreshToken'),
          }),
        }
      );

      if (!response.ok) {
        return;
      }
      signOut();
      localStorage.setItem('username', '');
      navigate('/');
    } catch (error) {
      const errorMessage = (error as Error).message || 'Unknown error';
      setError(errorMessage);
      setSnackbarOpen(true);
    }
  };

  const handleCloseSnackbar = () => {
    setSnackbarOpen(false);
  };

  return (
    <>
      {isMobile ? (
        <Typography onClick={handleSignOut} sx={{ cursor: 'pointer' }}>
          Logout
        </Typography>
      ) : (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <Typography
            color="white"
            sx={{ pr: 2, cursor: 'pointer' }}
            onClick={() => navigate('/municipality/view')}
          >
            {username}
          </Typography>
          <IconButton onClick={handleSignOut} data-testid="logout-button">
            <LogoutIcon sx={{ color: 'white' }} />
          </IconButton>
        </Box>
      )}

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity="error"
          sx={{ width: '100%' }}
        >
          {error}
        </Alert>
      </Snackbar>
    </>
  );
};

export default SignOutButton;
